// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"48":"4ac9a551a60e7d86","195":"81f63b83c6a539df","9930":"f27de46e30878dfa"}[chunkId] + ".css";
};